/**
 * @generated SignedSource<<602bd9fb29a0f0523768f48a776c6a3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoDetailScreenGenerateCSVMutation$variables = {
  todoWorkspaceId: string;
};
export type WorkspaceTodoDetailScreenGenerateCSVMutation$data = {
  readonly todoWorkspace: {
    readonly generateExportCSV: string | null;
  };
};
export type WorkspaceTodoDetailScreenGenerateCSVMutation = {
  response: WorkspaceTodoDetailScreenGenerateCSVMutation$data;
  variables: WorkspaceTodoDetailScreenGenerateCSVMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoWorkspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "todoWorkspaceId"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "generateExportCSV",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoDetailScreenGenerateCSVMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoDetailScreenGenerateCSVMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29e352f069b931d2280effe082d47548",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoDetailScreenGenerateCSVMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoDetailScreenGenerateCSVMutation(\n  $todoWorkspaceId: ID!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    generateExportCSV\n  }\n}\n"
  }
};
})();

(node as any).hash = "3efd63c84b16c5910d9c50f878b3236c";

export default node;
